import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Index from '@/components/Index'
import Welcome from '@/components/Welcome'
import Userinfo from '@/components/userinfo/Userinfo'
import articleType from '@/components/articleType/articleType'
import articleLabel from '@/components/articleLabel/articleLabel'
import myProject from '@/components/myproject/myProject'
import Links from '@/components/links/links'
import auditLinks from '@/components/links/auditLinks'
import Message from '@/components/message/message'
import About from '@/components/about/about'
import Article from '@/components/article/article'



Vue.use(Router)


const router =  new Router({
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/index',
      name: 'Index',
      component: Index,
      redirect: '/welcome',
      children:[
        {
          path: '/welcome',
          name: 'Welcome',
          component: Welcome
        },
        {
          path: '/userinfo',
          name: 'Userinfo',
          component: Userinfo
        },
        {
          path: '/articleType',
          name: 'articleType',
          component: articleType
        },
        {
          path: '/articleLabel',
          name: 'articleLabel',
          component: articleLabel
        },
        {
          path: '/myProject',
          name: 'myProject',
          component: myProject
        },
        {
          path: '/links',
          name: 'Links',
          component: Links
        },
        {
          path: '/auditLinks',
          name: 'auditLinks',
          component: auditLinks
        },
        {
          path: '/message',
          name: 'Message',
          component: Message
        },
        {
          path: '/about',
          name: 'About',
          component: About
        },
        {
          path: '/article',
          name: 'Article',
          component: Article
        },
      ]
    },
  ]
})

// 挂载路由导航守卫
router.beforeEach((to,from,next) => {
  // to 将要访问的路径
  // from 从哪个路径跳转而来
  // next 是一个函数，表示放行

  if(to.path === '/login') return next();
  // 获取token
  const tokenStr = window.sessionStorage.getItem('token');
  if(!tokenStr) return next('/login');
  next();
})

export default router




// WEBPACK FOOTER //
// ./src/router/index.js